import {
  FeatureArrayData,
  FeaturePromotionProps,
  FeaturesConfig,
} from '#/service/config';

import { useConfig } from './useConfig';

/**
 * Hook that gives easy access to information about enabled features (it gets it from Spec JSON Config)
 */
export function useFeaturesInfo() {
  const { features } = useConfig();

  return {
    /**
     * Helper function to check if any feature of given type is enabled (or feature with particular key if you provide it)
     * @param feature Feature name that you wish to check.
     * @param key (optional) feature key that you wish to check.
     */
    isFeatureEnabled: (feature: keyof FeaturesConfig, key?: string) => {
      const featureObject = (features[feature] ??
        []) as FeatureArrayData<unknown>;

      return featureObject.some(
        (feature) => feature.enabled && (!key || feature.key === key)
      );
    },

    // TODO: Standardize features in configuration! Sometimes we identify feature by key, sometimes by type and sometimes by type in the properties. It hurts :(
    getPromoFeature: (type: string) => {
      const featureObject = (features.promotions ??
        []) as FeatureArrayData<FeaturePromotionProps>;

      return featureObject.find((feature) => feature.properties.type === type);
    },
  };
}
